import { render, staticRenderFns } from "./Personphone.vue?vue&type=template&id=adc536ba&scoped=true&"
import script from "./Personphone.vue?vue&type=script&lang=js&"
export * from "./Personphone.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/content.css?vue&type=style&index=0&id=adc536ba&scoped=true&lang=css&"
import style1 from "./Personphone.vue?vue&type=style&index=1&id=adc536ba&scoped=true&lang=css&"
import style2 from "./Personphone.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc536ba",
  null
  
)

export default component.exports